module.exports = __webpack_public_path__ + "img/avlogo.7d2ea0bf.svg";